import { ClientError, GraphQLClient } from "graphql-request";

export const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_GRAPHQL_ENDPOINT || "http://localhost:5001/api/graphql";

/** Authenticated GraphQL client for the given access token. */
export const createGraphQLClient = (accessToken: string | null) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }

  return new GraphQLClient(GRAPHQL_ENDPOINT, { headers });
};

/** The `extensions.code` of the first GraphQL error, if the request failed with one. */
export const graphQLErrorCode = (error: unknown): string | undefined => {
  if (!(error instanceof ClientError)) {
    return undefined;
  }

  const code = error.response.errors?.[0]?.extensions?.code;

  return typeof code === "string" ? code : undefined;
};
